export default {"src":"/_next/static/media/UKFlag.2bc15cf6.svg","height":24,"width":32};